module.exports = __webpack_public_path__ + "img/amg-model-g63-used-car.4b62da1a.jpg";